<template>
  <div
    class="
      card
      shadow-sm
      text-dark text-start
      max-card-height
      d-flex
      flex-column
      d-flex
      flex-column
    "
  >
    <div class="card-header fs-6 fw-bold">Survey Topics</div>
    <div class="card-body p-2 flex-grow-1 overflow-auto">
      <div v-for="topic in questionTopics" :key="topic">
        <div>
          <TopicCard :topic="topic" :questions="questionData" />
        </div>
      </div>
      <div>
        <div
          class="card my-2"
          :class="[
            {
              'border-dark border-3': isCurrentTopic('Summary')
            }
          ]"
        >
          <div
            class="
              card-header
              fw-bold
              d-flex
              justify-content-between
              align-items-center
              btn
            "
            @click="selectSummary()"
          >
            <span>Summary</span>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer text-center p-2 pb-3 mt-auto">
      <div class="my-2">
        Step {{ currentStep }} of {{ totalQuestionsCount }}
      </div>
      <div class="progress">
        <div
          class="progress-bar w-50"
          role="progressbar"
          :style="{ width: progressPercentage + '%' }"
          :aria-valuenow="progressPercentage"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TopicCard from "@/components/TopicCard.vue";

export default {
  name: "TableOfContents",
  components: { TopicCard },
  data() {
    return {
      questionTopics: []
    };
  },
  props: {
    questionData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  computed: {
    ...mapGetters(["getSurveyAnswers", "getCurrentQuestion"]),
    answeredQuestionsCount() {
      return this.getSurveyAnswers.length;
    },
    totalQuestionsCount() {
      return this.questionData.length;
    },
    progressPercentage() {
      if (this.totalQuestionsCount === 0) return 0;
      return Math.round(
        (this.answeredQuestionsCount / this.totalQuestionsCount) * 100
      );
    },
    currentStep() {
      const currentQuestionIndex = this.questionData.findIndex(
        (question) => question.uuid === this.getCurrentQuestion?.uuid
      );
      return currentQuestionIndex + 1;
    }
  },
  methods: {
    ...mapActions(["setCurrentQuestion"]),
    isCurrentTopic(topic) {
      return this.getCurrentQuestion?.topic === topic;
    },
    updateTopics(questionsLoaded) {
      const uniqueTopics = new Set();
      questionsLoaded?.forEach((question) => {
        if (question.topic) {
          uniqueTopics.add(question.topic);
        }
      });
      this.questionTopics = Array.from(uniqueTopics);
    },
    selectSummary() {
      this.setCurrentQuestion("Summary");
    }
  },
  watch: {
    questionData: {
      handler(newVal) {
        if (newVal) {
          this.updateTopics(newVal);
        }
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.max-card-height {
  max-height: 700px;
}
.card-body {
  overflow-y: auto;
}
</style>
